import { useState } from 'react';
import useReveal from './useReveal';

const contactItems = [
  {
    icon: <svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
    label: 'Head Office',
    value: '25 Langa Crescent, 4b Corridor\nHighveld, Witbank, Mpumalanga 1039',
  },
  {
    icon: <svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.49 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.34 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.4a16 16 0 0 0 5.55 5.55l.77-.77a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21 16.92z"/></svg>,
    label: 'Phone',
    value: '082 798 8620 / 013 650 0404\n013 650 0025',
  },
  {
    icon: <svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
    label: 'Email',
    value: 'forster@fmmaepa.co.za\nwww.fmmaepa.co.za',
  },
  {
    icon: <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
    label: 'Office Hours',
    value: 'Monday – Friday: 07:00 – 16:00',
  },
];

export default function Contact() {
  const ref = useReveal();
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', company: '', service: '', message: '' });

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 3000);
    setForm({ firstName: '', lastName: '', email: '', company: '', service: '', message: '' });
  };

  return (
    <section id="contact">
      <div className="contact-grid reveal" ref={ref}>
        <div className="contact-left">
          <div className="eyebrow">Get In Touch</div>
          <h2 className="sec-title">Let's Work<br />Together</h2>
          <p>
            Allow our team to deliver exceptional service that reflects our commitment to your utmost
            convenience. Serving clients across the private, professional, and public sectors.
          </p>
          {contactItems.map(c => (
            <div className="ci" key={c.label}>
              <div className="ci-icon">{c.icon}</div>
              <div>
                <div className="ci-lbl">{c.label}</div>
                <div className="ci-val" style={{ whiteSpace: 'pre-line' }}>{c.value}</div>
              </div>
            </div>
          ))}
        </div>

        <form className="cf" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="fg">
              <label>First Name</label>
              <input name="firstName" value={form.firstName} onChange={handleChange} placeholder="John" />
            </div>
            <div className="fg">
              <label>Last Name</label>
              <input name="lastName" value={form.lastName} onChange={handleChange} placeholder="Doe" />
            </div>
          </div>
          <div className="fg">
            <label>Email</label>
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="your@email.co.za" />
          </div>
          <div className="fg">
            <label>Company</label>
            <input name="company" value={form.company} onChange={handleChange} placeholder="Company Name" />
          </div>
          <div className="fg">
            <label>Service Required</label>
            <select name="service" value={form.service} onChange={handleChange}>
              <option value="">Select a service...</option>
              <option>Mechanical Engineering</option>
              <option>Civil Engineering</option>
              <option>Project &amp; Programme Management</option>
              <option>Mining Services</option>
              <option>Other</option>
            </select>
          </div>
          <div className="fg">
            <label>Message</label>
            <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your project..." />
          </div>
          <button type="submit" className={`sbtn ${sent ? 'sent' : ''}`}>
            {sent ? 'Message Sent ✓' : 'Send Message →'}
          </button>
        </form>
      </div>
    </section>
  );
}
